const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const withRetry = async (fn, { retries = 2, delay = 300 } = {}) => {
  let attempt = 0;
  let lastError;
  while (attempt <= retries) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;
      if (attempt === retries) break;
      const backoff = delay * Math.pow(2, attempt);
      await wait(backoff);
    }
    attempt += 1;
  }
  throw lastError;
};

export default withRetry;
